import React, { useState, useEffect } from 'react';
import { registerModal, unregisterModal } from '../modalController';
import { lockBodyScroll, unlockBodyScroll } from './modalBehavior';

const DataExportMessagePopup = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isVisible, setIsVisible] = useState(false);

    const close = () => {
        unlockBodyScroll();
        setIsOpen(false);
        setIsVisible(false);
    };

    useEffect(() => {
        registerModal('dataExportMessageModal', () => {
            lockBodyScroll();
            setIsOpen(true);
            requestAnimationFrame(() => setIsVisible(true));
        });
        return () => unregisterModal('dataExportMessageModal');
    }, []);

    useEffect(() => {
        if (!isOpen) {
            return;
        }
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                close();
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [isOpen]);

    return (
        <div>
            <div className={`modal fade ${isVisible ? 'show' : ''}`} id="dataExportMessageModal" style={{ display: isOpen ? 'block' : 'none' }} aria-hidden={!isOpen}>
                <div className="modal-dialog">
                    <div className="modal-content">

                        <div className="modal-header">
                            <h5 className="modal-title">
                                Data Export Request
                            </h5>
                            <button type="button" className="close" onClick={close}>&times;</button>
                        </div>

                        <div className="modal-body">
                            <p className='bd-highlight' style={{ fontSize: '0.9rem' }}>
                                The data export feature is only available to our subscribed users.
                                Look into our <a className='red' href="/pricing" target="_blank" rel="noopener noreferrer"><strong><u>different plans</u></strong></a>{' '}
                                or contact sales to tailor a package to suit your needs.
                            </p>
                        </div>

                        <div className="modal-footer">
                            <a type="button" className="btn btn-main btn-md" href="/pricing" target="_blank" rel="noopener noreferrer">
                                Contact Sales
                            </a>
                        </div>

                    </div>
                </div>
            </div>
            {isOpen && <div className="modal-backdrop fade show"></div>}
        </div>
    )
}

export default DataExportMessagePopup;